import { useEffect, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";

import Login from "./pages/Login.jsx";
import FinishSignIn from "./pages/FinishSignIn.jsx";
import AppContent from "./components/AppContent.jsx";
import SharedView from "./pages/SharedView.jsx";

function RequireAuth({ children }) {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    return onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
  }, []);

  if (loading) return <div style={{ padding: 24 }}>Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Route path="/login" element={<Login />} />
      <Route path="/finish-signin" element={<FinishSignIn />} />

      <Route
        path="/"
        element={
          <RequireAuth>
            <AppContent />
          </RequireAuth>
        }
      />

      <Route path="/shared/:token" element={<SharedView />} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}